<template>
	<v-dialog v-model="dialog" max-width="500">
		<v-card>
			<v-card-title>Nova Solicitação</v-card-title>
			<v-card-text>
				<v-form ref="form" v-model="valid">
					<v-select
						v-model="solicitacao.tipo"
						:items="tipoOptions"
						label="Tipo"
						dense
						:rules="[v => !!v || 'Obrigatório']"
						@change="onTipoChange"
					></v-select>
					<v-text-field
						v-model="solicitacao.data_solicitacao"
						label="Data"
						type="date"
						dense
						:min="new Date().toISOString().substr(0, 10)"
					></v-text-field>
					<v-row v-if="solicitacao.tipo === 'Troca dia/turno'" dense>
						<v-col cols="6">
							<v-select
								v-model="solicitacao.turno_atual"
								:items="turnos"
								item-text="turno"
								item-value="idturnos"
								label="Turno Atual"
								dense
								:rules="trocaRules"
							></v-select>
						</v-col>
						<v-col cols="6">
							<v-select
								v-model="solicitacao.turno_desejado"
								:items="turnos"
								item-text="turno"
								item-value="idturnos"
								label="Turno Desejado"
								dense
								:rules="trocaRules"
							></v-select>
						</v-col>
					</v-row>
					<v-textarea
						v-model="solicitacao.justificativa"
						label="Justificativa"
						dense
						rows="2"
						:rules="[v => !!v || 'Obrigatório']"
					></v-textarea>
					<v-file-input
						v-if="solicitacao.tipo === 'Outros'"
						v-model="atestado"
						label="Atestado (opcional)"
						dense
						accept="image/*,.pdf"
						@change="onFileChange"
					></v-file-input>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="reset">Cancelar</v-btn>
				<v-btn color="primary" @click="save" :loading="loading" :disabled="!valid">Enviar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import Bus from '@/barramento'

export default {
	name: 'DialogNovaSolicitacao',
	data() {
		return {
			dialog: false,
			valid: false,
			loading: false,
			atestado: null,
			turnos: [],
			solicitacao: {
				tipo: '',
				data_solicitacao: new Date().toISOString().substr(0, 10),
				turno_atual: '',
				turno_desejado: '',
				justificativa: '',
				atestado_medico: null
			},
			tipoOptions: [
				'Troca dia/turno',
				'Folga',
				'Outros'
			],
			trocaRules: [v => !!v || 'Obrigatório']
		}
	},
	methods: {
		show() {
			this.loadTurnos()
			this.dialog = true
		},
		async loadTurnos() {
			try {
				const response = await axios.get(`${baseApiUrl}/turnos`)
				this.turnos = response.data
			} catch (err) {
				showError(err)
			}
		},
		onTipoChange() {
			if (this.solicitacao.tipo !== 'Troca dia/turno') {
				this.solicitacao.turno_atual = ''
				this.solicitacao.turno_desejado = ''
			}
		},
		async onFileChange(file) {
			if (file) {
				const formData = new FormData()
				formData.append('file', file)
				
				try {
					const response = await axios.post(`${baseApiUrl}/upload`, formData, {
						headers: { 'Content-Type': 'multipart/form-data' }
					})
					this.solicitacao.atestado_medico = response.data.filename
				} catch (err) {
					showError(err)
				}
			}
		},
		async save() {
			if (!this.$refs.form.validate()) return
			
			this.loading = true
			try {
				await axios.post(`${baseApiUrl}/solicitacoes`, this.solicitacao)
				this.$toasted.global.defaultSuccess()
				Bus.$emit('reload')
				this.reset()
			} catch (err) {
				showError(err)
			} finally {
				this.loading = false
			}
		},
		reset() {
			this.dialog = false
			this.solicitacao = {
				tipo: '',
				data_solicitacao: new Date().toISOString().substr(0, 10),
				turno_atual: '',
				turno_desejado: '',
				justificativa: '',
				atestado_medico: null
			}
			this.atestado = null
			this.$refs.form?.resetValidation()
		}
	},
	mounted() {
		Bus.$on('novaSolicitacao', this.show)
	},
	beforeDestroy() {
		Bus.$off('novaSolicitacao', this.show)
	}
}
</script>